import { render, staticRenderFns } from "./PanelCompetitionSettingRegulation.vue?vue&type=template&id=18437bf5&scoped=true&"
import script from "./PanelCompetitionSettingRegulation.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionSettingRegulation.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionSettingRegulation.vue?vue&type=style&index=0&id=18437bf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18437bf5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18437bf5')) {
      api.createRecord('18437bf5', component.options)
    } else {
      api.reload('18437bf5', component.options)
    }
    module.hot.accept("./PanelCompetitionSettingRegulation.vue?vue&type=template&id=18437bf5&scoped=true&", function () {
      api.rerender('18437bf5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelCompetitionSettingRegulation.vue"
export default component.exports